module.exports = __webpack_public_path__ + "img/earn-error.0321cec1.png";